import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { ReceivableService } from 'src/app/services/receivable.service';
import { PaymentChannel } from 'src/app/models/receivable';
import { Router, ActivatedRoute } from '@angular/router';
import uuidv4 from 'uuid/v4';
import { PaymentService } from 'src/app/services/payment.service';

declare var $: any;

@Component({
  selector: 'app-payment-channel',
  templateUrl: './payment-channel.component.html',
  styleUrls: ['./payment-channel.component.css']
})
export class PaymentChannelComponent implements OnInit {
  public channels: PaymentChannel[] = [];
  public isLoading = true;
  activeVACode = '';
  dataParam: any;
  requestID: any;
  message = '';

  constructor(
    public receivableService: ReceivableService,
    private paymentService: PaymentService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.generateReqID();
    this.getParam();
    this.getPaymentChannel();
  }

  generateReqID() {
    this.requestID = uuidv4();
  }

  getParam() {
    const param = this.route.snapshot.paramMap.get('data');
    this.dataParam = JSON.parse(atob(param));
  }

  getPaymentChannel() {
    this.receivableService.getPaymentChannel(
      (data) => {
        this.channels = data;
        this.isLoading = false;
      },
      err => {
        console.log(err);
      });
  }

  setVACode(code: string) {
    this.activeVACode = code;
  }

  otherPaymentChannel(item) {
    const data = this.route.snapshot.paramMap.get('data');
    const channel = btoa(JSON.stringify(item));

    this.router.navigate([`/receivable/other-payment-channel/${data}/${channel}`]);
  }

  toProcessPayment() {
    this.isLoading = true;
    const obj = this.setObjectParam();
    this.paymentService.createPayment(obj, (response) => {
      this.isLoading = false;
      if (response.alert.code === 200) {
        const { data } = response;
        const object = { id: data.transactionId, status: 0, total: 0 };
        const param = btoa(JSON.stringify(object));
        this.router.navigate([`/receivable/process-payment/${param}`]);
      } else {
        const { alert } = response;
        this.message = alert.message;
        $('#notif').modal('show');
      }
    },
      (err) => {
        console.log(err);
        this.message = err;
        $('#notif').modal('show');
      });
  }

  handleOKNotif() {
    $('#notif').modal('hide');
  }

  setObjectParam() {
    const obj = {
      requestId: this.requestID,
      code: this.activeVACode,
      items: this.setListItem()
    }
    return obj;
  }

  setListItem() {
    let result = [];
    this.dataParam.forEach(item => {
      const obj = {
        contextId: item.invoice_number,
        quantity: 1,
        totalBill: item.credit_value,
        invoiceDate: item.invoice_date
      }
      result.push(obj);
    });

    return result;
  }
}
